export class UnitModel {

  public id?: number;
  public name?: string;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    }
  }
}
